import * as React from "react";
import classnames from "classnames";
import {
  isMaxLengthValidation,
  ITextInputElement,
} from "@graffer-inc/form-schema";
import { TenantProcessResultInputElementValidator } from "@graffer-inc/cloud-gov-core";

import { BaseModal } from "../../../atoms/base-modal";
import { ToggleField } from "@graffer-inc/smart-apply";
import { ErrorMessage } from "./../../../atoms/error-message";

type TenantProcessResultDetailModalProps = {
  isReadonly: boolean;
  isActive: boolean;
  element: ITextInputElement;
  touched: boolean | undefined;
  setTouched: () => void;
  onClose: () => void;
  onUpdate: (element: ITextInputElement) => void;
};

export const TenantProcessResultDetailModal: React.FC<
  TenantProcessResultDetailModalProps
> = ({
  isReadonly,
  isActive,
  element,
  touched,
  setTouched,
  onClose,
  onUpdate,
}) => {
  const [editElement, setEditElement] =
    React.useState<ITextInputElement>(element);

  const elementValidator = React.useMemo(
    () => new TenantProcessResultInputElementValidator(editElement),
    [editElement],
  );
  const maxLengthValidation = React.useMemo(
    () => editElement.validations.find(isMaxLengthValidation),
    [editElement.validations],
  );

  const handleChange = React.useCallback(
    (value: string | number | undefined) => {
      setTouched();
      setEditElement({
        ...editElement,
        validations: !value
          ? []
          : [
              {
                keyword: "maxLength",
                value,
              },
            ],
      });
    },
    [setEditElement, editElement, setTouched],
  );
  const handleClickSave = React.useCallback(() => {
    onUpdate(editElement);
    onClose();
  }, [onUpdate, onClose, maxLengthValidation]);

  return (
    <>
      <BaseModal isActive={isActive} title="詳細設定" onClose={onClose}>
        <section className="modal-card-body">
          <ToggleField
            label="最大文字数"
            isOn={!!maxLengthValidation}
            setOn={() => handleChange(1)}
            setOff={() => handleChange(undefined)}
            disabled={isReadonly}
          >
            <div className="control">
              {isReadonly ? (
                <div className="is-vcentered">{maxLengthValidation?.value}</div>
              ) : (
                <input
                  className={classnames("input", {
                    "is-danger": touched && elementValidator.validations(),
                  })}
                  type="number"
                  value={maxLengthValidation?.value}
                  onChange={(e) => handleChange(Number(e.target.value))}
                  onBlur={setTouched}
                />
              )}
            </div>
          </ToggleField>
          <ErrorMessage
            msg={touched ? elementValidator.validations() : undefined}
          />
        </section>
        <footer className="modal-card-foot">
          <button className="button is-failure is-fullwidth" onClick={onClose}>
            キャンセル
          </button>
          <button
            className="button is-info is-fullwidth"
            disabled={isReadonly || !!elementValidator.validations()}
            onClick={handleClickSave}
          >
            設定する
          </button>
        </footer>
      </BaseModal>
    </>
  );
};
